import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OAuthCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        const username = params.get("username"); // Extract the username

        if (token) {
            localStorage.setItem("access_token", token);
            if (username) {
                localStorage.setItem("username", username); 
            }

            navigate("/user");
        } else {
            alert("Authentication failed.");
            navigate("/login");
        }
    }, [navigate]);

    return <div>Processing authentication...</div>;
};

export default OAuthCallback;
